import axios from "axios";
import { refreshToken } from "./authService";
import apiConfig from "../config/apiConfig";

// Axios instance oluştur
const axiosInstance = axios.create({
  baseURL: apiConfig.baseURL,
  timeout: apiConfig.timeout,
});

// Request interceptor - her istekte token ekle
axiosInstance.interceptors.request.use(
  (config) => {
    // Refresh token endpoint'i için token ekleme
    if (config.url?.includes("refreshToken") || config.url?.includes("authenticate")) {
      return config;
    }

    const token = localStorage.getItem("authToken");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - 401 hatalarında refresh token dene
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    // 401 veya 403 hatası, henüz retry yapılmamışsa ve refresh token endpoint'i değilse
    // VE refresh token varsa
    const refreshTokenValue = localStorage.getItem("refreshToken");
    if (
      (error.response?.status === 401 || error.response?.status === 403) &&
      !originalRequest._retry &&
      !originalRequest.url?.includes("refreshToken") &&
      !originalRequest.url?.includes("authenticate") &&
      refreshTokenValue // Refresh token varsa dene
    ) {
      originalRequest._retry = true;

      try {
        // Refresh token ile yeni token al
        const newToken = await refreshToken();

        // Yeni token ile orijinal isteği tekrarla
        originalRequest.headers.Authorization = `Bearer ${newToken}`;
        return axiosInstance(originalRequest);
      } catch (refreshError) {
        // Refresh token da geçersizse sadece localStorage'ı temizle
        localStorage.removeItem("authToken");
        localStorage.removeItem("refreshToken");
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
